<template>
  <div class="todo-header">
    <input type="text" v-model="newTodo" @keyup.enter="addNewTodo()" />
  </div>
</template>

<script lang="ts">
import { TodoService } from "@/services/todo.service";
import { useService } from "use-vue-service";
import { defineComponent, ref } from "vue";

export default defineComponent({
  setup() {
    const newTodo = ref("");
    const todoService = useService(TodoService);
    const addNewTodo = () => {
      todoService.addTodo(newTodo.value);
      newTodo.value = "";
    };
    return {
      addNewTodo,
      newTodo
    };
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.todo-header {
  text-align: center;
  padding: 5px 0;
  border-bottom: 1px solid #666;

  input[type="text"] {
    font-size: 24px;
  }
}
</style>
